import React, { useState } from 'react';
import { Select } from 'antd';
import i18next from 'i18next';
import Eng from '../../assets/images/uk_flag.png';
import Cz from '../../assets/images/cz_flag.png';
import Itl from '../../assets/images/it_flag.png';

export const DropdownSelect: React.FC = () => {
  const [language, setLanguage] = useState<string>(i18next.language);

  const handleTranslation = (value: string) => {
    setLanguage(value);
    setTimeout(() => {
      window.location.reload();
      i18next.changeLanguage(value);
    }, 1000);
  };

  return (
    <Select
      defaultValue="en"
      style={{ width: '105px' }}
      onChange={handleTranslation}
      value={language}
    >
      <Select.Option value="en">
        <img
          src={Eng}
          alt="mca-english"
          style={{ width: '35px', marginRight: '10px' }}
        />
        EN
      </Select.Option>
      <Select.Option value="cz">
        <img
          src={Cz}
          alt="mca-czech"
          style={{ width: '35px', marginRight: '10px' }}
        />
        CZ
      </Select.Option>
      <Select.Option value="it">
        <img
          src={Itl}
          alt="mca-italian"
          style={{ width: '35px', marginRight: '10px' }}
        />
        IT
      </Select.Option>
    </Select>
  );
};
